module.exports = __webpack_public_path__ + "img/ossetia.f8e9ff2d.svg";